import { classNames } from "Utils/utils";

// Yes/No/NA Toggle Component
export const YesNoToggle = ({ name, value, onChange, showNA = false }) => {
  const options = showNA
    ? [
        { val: "yes", label: "Yes" },
        { val: "no", label: "No" },
        { val: "na", label: "N/A" },
      ]
    : [
        { val: "yes", label: "Yes" },
        { val: "no", label: "No" },
      ];

  return (
    <div className="inline-flex rounded-lg border border-gray-200 p-0.5 bg-gray-50">
      {options.map((opt) => (
        <button
          key={opt.val}
          type="button"
          onClick={() => onChange(opt.val)}
          className={classNames(
            "px-3 py-1.5 text-xs font-medium rounded-md transition-all",
            value === opt.val
              ? opt.val === "yes"
                ? "bg-green-500 text-white"
                : opt.val === "no"
                ? "bg-red-500 text-white"
                : "bg-gray-500 text-white"
              : "text-gray-600 hover:bg-gray-100"
          )}
        >
          {opt.label}
        </button>
      ))}
    </div>
  );
};
